export default __webpack_public_path__ + "static/media/train22.1d960b83.png";